<template>
  <div class="content-wapper">
    <el-row class="navigation">
      <el-col align="left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
          <el-breadcrumb-item>小微企业查询</el-breadcrumb-item>
        </el-breadcrumb>
        <!--
        <span>当前位置: &nbsp;&nbsp;</span>
        <span>小微企业成长服务 </span>
        <span>&nbsp; &gt; &nbsp;</span>
        <el-link :underline="false" @click="refresh" class="router"> 小微企业查询</el-link>
        -->
      </el-col>
    </el-row>

    <div class="search-where">
      <div class="search-item">
        <div class="search-item-left">
          搜索查询：
        </div>
        <div>
			<el-input placeholder="请输入完整的统一社会信用代码/企业名称" style="width: 600px;margin-right: 30px" clearable v-model="queryParams.entname"  prefix-icon="el-icon-search" >
			</el-input>
          <!-- <el-input placeholder="请输入统一社会信用代码" style="width: 300px;padding-right: 30px" v-model="queryParams.uniscid"  prefix-icon="el-icon-search">
          </el-input>
          <el-input placeholder="请输入企业名称" style="width: 300px;padding-right: 30px" v-model="queryParams.entname"  prefix-icon="el-icon-search">
          </el-input> -->
          <el-button slot="append" type="primary" @click="getList">搜索</el-button>
        </div>
      </div>
    </div>

    <div class="search-table">
      <el-table v-loading="loading" :data="nbaseinfoList" >
        <el-table-column label="标题" align="center" prop="entname">
          <template slot-scope="scope">
            <el-button type="text" @click="openDetail(scope.row)">{{scope.row.entname}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="统一社会信用代码" align="center" prop="uniscid"/>
        <el-table-column label="注册资本(万元)" align="center" prop="regcap"/>
        <el-table-column label="企业类型" align="center" prop="enttype" :formatter="enttypesFormat"/>
        <el-table-column label="登记机关" align="center" prop="regorgCn"/>
      </el-table>
    </div>

    <div class="search-page">
      <div class="search-page-page">
        <el-pagination class="pagination"
		   @size-change="handleSizeChange"
		   @current-change="handleCurrentChange"
		   :current-page.sync="queryParams.pageNum"
		   :page-size="queryParams.pageSize"
		   :hide-on-single-page="true"
		   layout="total, prev, pager, next"
		   :total="total"
		   @pagination="getList">
        </el-pagination>
      </div>
    </div>

    <!--小微企业详情-->
    <el-dialog title="小微企业详情" :visible.sync="detailOpen" width="800px" append-to-body>
      <div class="yjrw-detail">
<!--        <div class="form-title">小微企业详情</div>-->
        <table>
          <tr>
            <td class="td-label">企业名称</td>
            <td class="td-value">{{xwqyJbxx.entname}}</td>
            <td class="td-label">统一社会信用代码</td>
            <td class="td-value">{{xwqyJbxx.uniscid}}</td>
          </tr>
          <tr>
            <td class="td-label">市场主体类型</td>
            <td class="td-value">{{enttypesFormat(null,null,xwqyJbxx.enttype)}}</td>
            <td class="td-label">成立日期</td>
            <td class="td-value">{{xwqyJbxx.estdate}}</td>
          </tr>
          <tr>
            <td class="td-label">注册资本</td>
            <td class="td-value">{{xwqyJbxx.regcap}}</td>
            <td class="td-label">登记机关</td>
            <td class="td-value">{{xwqyJbxx.regorgCn}}</td>
          </tr>
          <tr>
            <td class="td-label">所属门类</td>
            <td class="td-value">{{industryphyFormat(null,null,xwqyJbxx.industryphy)}}</td>
            <td class="td-label">行业</td>
            <td class="td-value">{{xwqyJbxx.industrycoCn}}</td>
          </tr>
          <tr>
            <td class="td-label">小微企业分类</td>
            <td class="td-value">{{xwqyJbxx.xwsortCn}}</td>
            <td class="td-label">加入时间</td>
            <td class="td-value">{{xwqyJbxx.addtime}}</td>
          </tr>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { listNbaseinfo,} from "@/api/xwqy/nbaseinfo";
  import {updatePvNum} from "@/api/itempv/pv";

  export default {
    name: "Xwqycx",
    data() {
      return {
        // 遮罩层
        loading: true,
        // 总条数
        total: 0,
        // 小微企业名录基本信息表格数据
        nbaseinfoList: [],
        // 是否显示弹出层
        open: false,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          uniscid: undefined,
          entname: undefined,
        },
        // 表单参数
        form: {},
        // 表单校验
        rules: {},
        enttypes: [],
        industryphys: [],
        detailOpen: false,
        xwqyJbxx: {},
      };
    },
    created() {
      this.getDicts("bd_enttype").then(response => {
        this.enttypes = response.data;
      });
      this.getDicts("INDUSTRYPHY").then(response => {
        this.industryphys = response.data;
      });
	  const en = JSON.parse(localStorage.getItem('IndexSearchContent'));
	  this.queryParams.entname = en;
      this.getList();
    },
    methods: {
      refresh(){
        this.getList();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.getList();
      },
      openDetail(row) {
        this.xwqyJbxx = row;
        this.detailOpen = true;
      },
      enttypesFormat(row, column, cellValue) {
        return this.selectDictLabel(this.enttypes, cellValue);
      },
      industryphyFormat(row, column, cellValue) {
        return this.selectDictLabel(this.industryphys, cellValue);
      },
      getList(){
        updatePvNum("xwqycz_xwqycx").then(response => {
          //pv 点击小微企业查询 或者点击了查询按钮
        });
        this.list=[];
        //判断查询条件是否为空，如果为空，那么是不允许查询的
        if((this.queryParams.entname == null || this.queryParams.entname ==='' || this.queryParams.entname ===undefined)
                &&( this.queryParams.uniscid == null || this.queryParams.uniscid ==='' || this.queryParams.uniscid === undefined)){
          this.nbaseinfoList = undefined;
          this.total =0;
          this.loading = false;
        }else{
        this.loading = true;
        listNbaseinfo(this.queryParams).then(response => {
          this.nbaseinfoList = response.rows;
          this.total = response.total;
          this.loading = false;
        });
          localStorage.removeItem("IndexSearchContent");
        }
      },
    }
  }
</script>

<style scoped>
  .content-wapper{
    margin-top: 5px;
    padding: 10px;
  }
  .navigation{
    padding:20px 15px;
    line-height: 20px;
    height: 60px;
    background-color: #F5F5F5;
    margin-bottom: 15px;
  }
  .el-divider--horizontal{
    margin: 12px 0px;
  }
  .search-item{
    display: flex;
    /*border-bottom: 1px solid #000000;*/
  }
  .search-item-left{
    line-height: 40px;
    font-weight: bold;
  }
  .search-item-right{
    flex: 1;
    padding: 0px 10px;
  }
  .item-right-select-ly{
    float: left;
    width: 85px;
    padding: 5px 10px;
    line-height: 30px;
    /*border: 1px solid #000000;*/
  }
  .item-right-select-status{
    float: left;
    /*width: 110px;*/
    padding: 5px 20px;
    line-height: 30px;
  }
  .el-button{
    border: 0px;
  }
  .el-button+.el-button{
    margin-left: 0;
  }
  .el-input-group__append button.el-button{
    background-color:#4A8DEC;
    color: #ffffff;
  }
  /deep/.el-input--medium .el-input__inner{
    height: 40px;
    line-height: 40px;
  }
  .el-input-group__append .el-button--medium{
    padding: 13px 30px;
  }
  .search-item-zr{
    flex: 1;
    padding: 0px 100px 0px 0px;
    text-align: right;
  }
  .button-zr{
    height: 40px;
    line-height: 20px;
  }
  .search-page{
    margin: 0px 15px 10px;
    padding: 20px 15px;
    background-color: #ffffff;
    display: flex;
  }
  .search-page-order{
    display: flex;

  }
  .order-filed{
    flex: 1;
    padding: 0px 15px;
    color:#000000;
  }
  .search-page-page{
    flex: 1;
    text-align: right;
  }
  .search-table{
    margin: 0px 15px;
    padding: 15px;
    background-color: #ffffff;
  }

  .danger-light {
    background-color: #F56C6C;
    padding: 5px 10px;
  }

  .warning-light {
    background-color: #E6A23C;
    padding: 5px 10px;
  }

  .success-light {
    background-color: #67C23A;
    padding: 5px 10px;
  }
  .font-success{
    color: #67C23A;
  }
  .font-danger{
    color: #F56C6C;
  }
  .font-blue{
    color: #409eff;
  }
  .search-item-right /deep/.el-button {
    background-color: #ffffff;
  }
  .form-title {
    line-height: 40px;
    border-top: 1px solid #E4EBF5;
    color: #409EFF;
    font-weight: bolder;
  }

  .yjrw-detail {
    width: 100%;
    font-size: 14px;
    color: #606266;
  }

  .yjrw-detail table {
    border: 1px solid #DCDFE6;
    width: 100%;
    border-collapse: collapse;
  }

  .yjrw-detail td {
    border: 1px solid #DCDFE6;
  }

  .td-label {
    width: 13.33%;
    text-align: right;
  }

  .td-value {
    width: 20%;
    text-align: left;
  }

  .td-label, .td-value {
    padding: 10px;
  }

  .zfry-item div {
    display: inline-block;
  }

  .zfcl-item div {
    display: inline-block;
  }

  .detail-list-table td {
    padding: 15px 10px;
    border-left: 1px solid #eeeeee;
    border-top: 1px solid #eeeeee;
    border-spacing: 0px;
  }

  .td-label {
    color: #959595;
    width: 13.3333%;
    text-align: right;
  }

  /deep/ .anchorBL {
    display: none;
  }

  .yjrw-detail1 table {
    border: 1px solid #DCDFE6;
    width: 100%;
    border-collapse: collapse;
  }

  .yjrw-detail1 td {
    border: 1px solid #DCDFE6;
  }

  .zfry-item div {
    display: inline-block;
  }

  .zfcl-item div {
    display: inline-block;
  }

  .navigation{
    padding:20px 15px;
    line-height: 20px;
    height: 60px;
    background-color: #F5F5F5;
    margin-bottom: 15px;
  }
</style>